(function () {
  console.log("LOCATION JS CARGADO");

  const LOCATION_STORAGE_KEY = "customer_location";
  const LOCATION_EVENTS_KEY = "__valhallaLocationEventsBound";
  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '[type="submit"][name="checkout"]',
    "#checkout",
    'a[href*="/checkout"]',
    ".cart__checkout-button",
    ".cart__ctas button",
    ".cart__ctas input",
    ".cart__ctas a",
    ".cart-drawer button[name=\"checkout\"]",
    ".cart-drawer input[name=\"checkout\"]",
    "cart-drawer-component button[name=\"checkout\"]",
    "cart-drawer-component input[name=\"checkout\"]",
    "cart-items-component button[name=\"checkout\"]",
    "cart-items-component input[name=\"checkout\"]",
    ".additional-checkout-buttons",
    ".shopify-payment-button__button",
    "shopify-accelerated-checkout-cart",
  ].join(",");

  let map;
  let marker;
  let autocomplete;
  let autocompleteInput;
  let autocompleteFocusHandler;
  let pacObserver;
  let mapReady = false;
  let mapInitPromise = null;
  let mapListeners = [];
  let mapContainerElement = null;
  let mapContainerHomeParent = null;
  let mapContainerHomeNextSibling = null;
  let checkoutStateRequestId = 0;
  let checkoutReady = false;
  let checkoutBlockReason = "";
  let checkoutSyncPromise = null;
  let checkoutUpdateTimer = null;
  let finalCheckoutValidationTimer = null;
  let finalCheckoutRevalidationPromise = null;
  let pendingFinalCheckoutRevalidation = false;
  let locationUiTimer = null;
  let resumeStateTimer = null;
  let bindButtonRetryTimer = null;
  let isManualSaveInProgress = false;
  let isReplayingCheckoutAttempt = false;
  let locationSaveQueue = Promise.resolve();

  function notifyCheckoutStateChanged(ready, reason) {
    document.dispatchEvent(
      new CustomEvent("valhalla:checkout-state-changed", {
        detail: {
          ready,
          reason,
        },
      })
    );
  }

  function toNumber(value) {
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function normalizeLatLng(lat, lng) {
    const normalizedLat = toNumber(lat);
    const normalizedLng = toNumber(lng);

    if (
      normalizedLat === null ||
      normalizedLng === null ||
      normalizedLat < -90 ||
      normalizedLat > 90 ||
      normalizedLng < -180 ||
      normalizedLng > 180
    ) {
      return null;
    }

    return {
      lat: normalizedLat,
      lng: normalizedLng,
    };
  }

  function extractLatLng(loc) {
    if (!loc) return null;

    const lat = typeof loc.lat === "function" ? loc.lat() : loc.lat;
    const lng = typeof loc.lng === "function" ? loc.lng() : loc.lng;

    return normalizeLatLng(lat, lng);
  }

  function normalizeLocationData(location) {
    const latLng = extractLatLng(location);
    if (!latLng) return null;

    return {
      ...location,
      ...latLng,
      address:
        typeof location.address === "string" && location.address.trim()
          ? location.address.trim()
          : "Ubicación seleccionada",
      googleMapsUrl:
        typeof location.googleMapsUrl === "string" && location.googleMapsUrl.trim()
          ? location.googleMapsUrl
          : `https://www.google.com/maps?q=${latLng.lat},${latLng.lng}`,
    };
  }

  function getStoredLocation() {
    const saved = localStorage.getItem(LOCATION_STORAGE_KEY);
    if (!saved) return null;

    try {
      const location = normalizeLocationData(JSON.parse(saved));

      if (!location) {
        localStorage.removeItem(LOCATION_STORAGE_KEY);
        return null;
      }

      return location;
    } catch (err) {
      localStorage.removeItem(LOCATION_STORAGE_KEY);
      return null;
    }
  }

  function isCheckoutControl(element) {
    if (!(element instanceof HTMLElement)) return;
    if (element.id === "openLocationModalBtn" || element.closest?.("#locationModal")) return false;

    if (
      element.matches(
        [
          'button[name="checkout"]',
          'input[name="checkout"]',
          '[type="submit"][name="checkout"]',
          "#checkout",
          'a[href*="/checkout"]',
          ".cart__checkout-button",
          ".additional-checkout-buttons",
          ".shopify-payment-button__button",
          "shopify-accelerated-checkout-cart",
        ].join(",")
      )
    ) {
      return true;
    }

    if (!element.closest(".cart__ctas")) return false;
    if (!element.matches("button,input,a")) return false;

    const label = `${element.textContent || ""} ${element.value || ""}`.toLowerCase();
    return /pagar|checkout|finalizar|comprar/.test(label);
  }

  function getCheckoutControls() {
    return [...new Set([...document.querySelectorAll(CHECKOUT_SELECTOR)].filter(isCheckoutControl))];
  }

  function getCheckoutVisualContainers(element) {
    const containers = [];
    let current = element.parentElement;

    while (current && current !== document.body && containers.length < 12) {
      containers.push(current);

      if (current.matches?.("cart-drawer-component, cart-items-component, dialog")) {
        break;
      }

      current = current.parentElement;
    }

    return [...new Set(containers.filter((container) => container instanceof HTMLElement))];
  }

  function releaseCheckoutVisualContainer(container) {
    if (!(container instanceof HTMLElement)) return;

    container.classList.remove("cart-items-disabled", "is-disabled", "disabled", "button--disabled", "loading");
    container.removeAttribute("aria-busy");
    container.removeAttribute("data-loading");
    container.removeAttribute("data-disabled");

    const computedStyle = window.getComputedStyle?.(container);
    const computedOpacity = Number.parseFloat(computedStyle?.opacity || "1");

    if (
      container.dataset.checkoutBlocked === "true" ||
      container.style.pointerEvents === "none" ||
      computedStyle?.pointerEvents === "none"
    ) {
      container.style.pointerEvents = "auto";
    }

    if (
      container.dataset.checkoutBlocked === "true" ||
      container.style.opacity === "0.5" ||
      (Number.isFinite(computedOpacity) && computedOpacity <= 0.55)
    ) {
      container.style.opacity = "1";
    }

    if (container.dataset.checkoutBlocked) {
      container.dataset.checkoutBlocked = "false";
      container.dataset.checkoutBlockReason = "";
    }

    if (container.style.cursor === "not-allowed") {
      container.style.cursor = "";
    }
  }

  function setCheckoutControlState(element, blocked, reason) {
    if (!(element instanceof HTMLElement)) return;

    if ("disabled" in element) {
      element.disabled = blocked;

      if (blocked) {
        element.setAttribute("disabled", "disabled");
      } else {
        element.removeAttribute("disabled");
      }
    } else if (!blocked) {
      element.removeAttribute("disabled");
    }

    element.setAttribute("aria-disabled", String(blocked));
    element.dataset.checkoutBlocked = blocked ? "true" : "false";
    element.dataset.checkoutBlockReason = blocked ? reason || "blocked" : "";
    element.style.opacity = blocked ? "0.5" : "1";
    element.style.pointerEvents = blocked ? "none" : "auto";
    element.style.cursor = blocked ? "not-allowed" : "";

    if (!blocked) {
      element.removeAttribute("aria-busy");
      element.removeAttribute("data-loading");
      element.removeAttribute("data-disabled");
      element.classList.remove("disabled", "is-disabled", "button--disabled", "cart-items-disabled", "loading");
      getCheckoutVisualContainers(element).forEach(releaseCheckoutVisualContainer);
    }
  }

  function applyCheckoutVisualState(blocked, reason = "") {
    getCheckoutControls().forEach((element) => {
      setCheckoutControlState(element, blocked, reason);
    });
  }

  function setCheckoutBlocked(blocked, reason = "") {
    const nextReady = !blocked;
    const nextReason = blocked ? reason || "blocked" : "";
    const changed = checkoutReady !== nextReady || checkoutBlockReason !== nextReason;

    checkoutReady = !blocked;
    checkoutBlockReason = nextReason;

    applyCheckoutVisualState(blocked, reason);

    if (changed) {
      notifyCheckoutStateChanged(checkoutReady, checkoutBlockReason);
    }
  }

  function scheduleCheckoutStateUpdate(delay = 120) {
    clearTimeout(checkoutUpdateTimer);
    checkoutUpdateTimer = setTimeout(() => {
      updateCheckoutState();
    }, delay);
  }

  function shouldForceShippingSync(state) {
    return Boolean(
      state &&
        !state.ready &&
        state.hasProducts &&
        state.hasLocation &&
        !state.isSyncing &&
        !checkoutSyncPromise &&
        window.Shipping?.applyShippingLogic
    );
  }

  function isShippingSyncing(state = null) {
    const shippingState = window.Shipping?.getSyncState?.();

    return Boolean(
      state?.isSyncing ||
        state?.pendingSync ||
        shippingState?.isProcessing ||
        shippingState?.pendingSync ||
        checkoutSyncPromise ||
        isManualSaveInProgress
    );
  }

  function isSystemUpdating(state = null) {
    return Boolean(isShippingSyncing(state) || (!state?.ready && window.CartObserver?.isBusy?.()));
  }

  function requestShippingSyncOnce(reason = "checkout-validation") {
    if (checkoutSyncPromise || !window.Shipping?.applyShippingLogic) {
      return checkoutSyncPromise;
    }

    setCheckoutBlocked(true, "syncing-shipping");

    checkoutSyncPromise = Promise.resolve(window.Shipping.applyShippingLogic())
      .catch((err) => {
        console.error("Error sincronizando shipping desde checkout:", err);
      })
      .finally(() => {
        checkoutSyncPromise = null;
        scheduleCheckoutStateUpdate(80);
      });

    return checkoutSyncPromise;
  }

  async function updateCheckoutState() {
    const requestId = ++checkoutStateRequestId;
    const location = getStoredLocation();

    if (!location) {
      setCheckoutBlocked(true, "missing-location");
      return false;
    }

    if (!window.Shipping?.validateCheckoutState) {
      setCheckoutBlocked(true, "shipping-not-ready");
      return false;
    }

    const state = await window.Shipping.validateCheckoutState();

    if (requestId !== checkoutStateRequestId) {
      return checkoutReady;
    }

    if (state.ready && !isShippingSyncing(state)) {
      setCheckoutBlocked(false);
      return true;
    }

    if (isSystemUpdating(state)) {
      setCheckoutBlocked(true, "syncing-shipping");
      return false;
    }

    if (shouldForceShippingSync(state)) {
      requestShippingSyncOnce("missing-or-invalid-shipping");
      return false;
    }

    setCheckoutBlocked(true, state.hasShipping ? "invalid-shipping" : "missing-shipping");

    return false;
  }

  function getCheckoutBlockReason(state) {
    if (!getStoredLocation() || state?.hasLocation === false) return "missing-location";
    if (state?.hasProducts === false) return "missing-products";
    if (state?.hasShipping) return "invalid-shipping";
    return "missing-shipping";
  }

  async function runFinalCheckoutRevalidation(reason = "final-validation") {
    clearTimeout(checkoutUpdateTimer);
    clearTimeout(finalCheckoutValidationTimer);
    finalCheckoutValidationTimer = null;

    const shippingSyncState = window.Shipping?.getSyncState?.();

    if (!shippingSyncState?.isProcessing && !shippingSyncState?.pendingSync) {
      checkoutSyncPromise = null;
    }

    checkoutStateRequestId += 1;

    if (!getStoredLocation()) {
      setCheckoutBlocked(true, "missing-location");
      return false;
    }

    if (!window.Shipping?.validateCheckoutState) {
      setCheckoutBlocked(true, "shipping-not-ready");
      return false;
    }

    const state = await window.Shipping.validateCheckoutState();
    const stillSyncing = isShippingSyncing(state);

    if (state.ready && !stillSyncing) {
      setCheckoutBlocked(false);
      return true;
    }

    if (stillSyncing) {
      setCheckoutBlocked(true, "syncing-shipping");
      return false;
    }

    setCheckoutBlocked(true, getCheckoutBlockReason(state));
    return false;
  }

  async function forceFinalCheckoutRevalidation(reason = "final-validation") {
    if (finalCheckoutRevalidationPromise) {
      pendingFinalCheckoutRevalidation = true;
      return finalCheckoutRevalidationPromise;
    }

    finalCheckoutRevalidationPromise = (async () => {
      let result = false;

      do {
        pendingFinalCheckoutRevalidation = false;
        result = await runFinalCheckoutRevalidation(reason);
      } while (pendingFinalCheckoutRevalidation);

      return result;
    })().finally(() => {
      finalCheckoutRevalidationPromise = null;

      if (pendingFinalCheckoutRevalidation) {
        scheduleFinalCheckoutValidation("pending-final-validation", 80);
      }
    });

    return finalCheckoutRevalidationPromise;
  }

  function scheduleFinalCheckoutValidation(reason = "final-validation", delay = 80) {
    clearTimeout(finalCheckoutValidationTimer);
    finalCheckoutValidationTimer = setTimeout(() => {
      finalCheckoutValidationTimer = null;
      forceFinalCheckoutRevalidation(reason);
    }, delay);
  }

  function schedulePostRenderCheckoutVisualSync(reason = "post-render") {
    scheduleFinalCheckoutValidation(`${reason}:post-render`, 40);

    if (typeof window.requestAnimationFrame === "function") {
      window.requestAnimationFrame(() => {
        forceFinalCheckoutRevalidation(`${reason}:raf`);
      });
    }

    setTimeout(() => {
      forceFinalCheckoutRevalidation(`${reason}:late`);
    }, 160);
  }

  function updateLocationButton() {
    const saved = getStoredLocation();

    document.querySelectorAll("#openLocationModalBtn").forEach((btn) => {
      btn.textContent = saved ? "📍 Cambiar ubicación de envío" : "📍 Agregar ubicación de envío";
      btn.classList.toggle("location-set", Boolean(saved));
    });
  }

  function syncLocationMessaging() {
    const hasLocation = Boolean(getStoredLocation());

    document.querySelectorAll(".cart-location-instructions").forEach((el) => {
      el.hidden = hasLocation;
      el.setAttribute("aria-hidden", String(hasLocation));
    });

    document.querySelectorAll("#locationSavedMessage").forEach((el) => {
      el.classList.toggle("active", hasLocation);
      el.hidden = !hasLocation;
      el.setAttribute("aria-hidden", String(!hasLocation));
    });
  }

  function resetSavedAddressUI() {
    document.querySelectorAll("#savedAddressText").forEach((el) => {
      el.textContent = "📍 Ubicación seleccionada";
    });

    document.querySelectorAll("#locationSavedMessage").forEach((el) => {
      el.classList.remove("active");
      el.hidden = true;
      el.setAttribute("aria-hidden", "true");
    });

    syncLocationMessaging();
  }

  function updateSavedAddressUI() {
    const data = getStoredLocation();

    if (!data || !data.address) {
      resetSavedAddressUI();
      return;
    }

    document.querySelectorAll("#savedAddressText").forEach((el) => {
      el.textContent = `📍 ${data.address}`;
    });

    document.querySelectorAll("#locationSavedMessage").forEach((el) => {
      el.classList.add("active");
      el.hidden = false;
      el.setAttribute("aria-hidden", "false");
    });

    syncLocationMessaging();
  }

  function waitForGoogleMaps(callback) {
    if (window.google?.maps?.places) {
      callback();
      return;
    }

    let attempts = 0;
    const interval = setInterval(() => {
      attempts += 1;

      if (window.google?.maps?.places) {
        clearInterval(interval);
        callback();
      }

      if (attempts >= 120) {
        clearInterval(interval);
        console.warn("Google Maps no estuvo listo a tiempo");
      }
    }, 100);
  }

  function resizeMapToMarker() {
    if (!map || !marker || !window.google?.maps) return;

    requestAnimationFrame(() => {
      google.maps.event.trigger(map, "resize");
      map.setCenter(marker.getPosition());
    });
  }

  function resizeMapAfterOpen() {
    resizeMapToMarker();
    setTimeout(resizeMapToMarker, 120);
    setTimeout(resizeMapToMarker, 350);
  }

  function waitForMapContainer() {
    setTimeout(() => {
      initMap();
      resizeMapToMarker();
    }, 300);
  }

  function getDefaultCenter() {
    return {
      lat: 14.0723,
      lng: -87.1921,
    };
  }

  function getInitialMapCenter(resolve) {
    const saved = getStoredLocation();

    if (saved) {
      resolve({
        lat: saved.lat,
        lng: saved.lng,
      });
      return;
    }

    if (!navigator.geolocation) {
      resolve(getDefaultCenter());
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        });
      },
      () => {
        resolve(getDefaultCenter());
      },
      {
        enableHighAccuracy: true,
        timeout: 7000,
        maximumAge: 60000,
      }
    );
  }

  function initMap() {
    const mapEl = document.getElementById("map");
    const input = document.getElementById("mapSearch");

    if (!mapEl || !input) {
      console.warn("Map o input no listos aún");
      return Promise.resolve(false);
    }

    if (mapReady && map && marker) {
      mapEl.classList.remove("loading");
      resizeMapToMarker();
      return Promise.resolve(true);
    }

    if (mapInitPromise) {
      return mapInitPromise;
    }

    mapEl.classList.add("loading");

    mapInitPromise = new Promise((resolve) => {
      waitForGoogleMaps(() => {
        getInitialMapCenter((center) => {
          buildMap(center);
          resolve(Boolean(mapReady));
        });
      });
    }).finally(() => {
      mapInitPromise = null;
    });

    return mapInitPromise;
  }

  function cleanupMapRuntime(clearInitPromise = true) {
    if (clearInitPromise) {
      mapInitPromise = null;
    }

    mapListeners.forEach((listener) => {
      if (!listener) return;

      if (typeof listener.remove === "function") {
        listener.remove();
      } else if (window.google?.maps?.event) {
        google.maps.event.removeListener(listener);
      }
    });
    mapListeners = [];

    if (autocompleteInput && autocompleteFocusHandler) {
      autocompleteInput.removeEventListener("focus", autocompleteFocusHandler);
    }

    autocompleteInput = null;
    autocompleteFocusHandler = null;

    if (pacObserver) {
      pacObserver.disconnect();
      pacObserver = null;
    }

    if (autocomplete && window.google?.maps?.event) {
      google.maps.event.clearInstanceListeners(autocomplete);
      autocomplete.unbindAll?.();
    }

    autocomplete = null;

    if (marker) {
      marker.setMap(null);
    }

    marker = null;
    map = null;
    mapReady = false;
  }

  function moveAutocompleteDropdown() {
    const pac = document.querySelector(".pac-container");
    const modalContent = document.querySelector(".location-modal__content");

    if (pac && modalContent && !modalContent.contains(pac)) {
      modalContent.appendChild(pac);
    }
  }

  function setupAutocomplete(input) {
    autocompleteInput = input;
    autocompleteFocusHandler = () => {
      input.dispatchEvent(new Event("input", { bubbles: true }));
    };
    input.addEventListener("focus", autocompleteFocusHandler);

    pacObserver = new MutationObserver(moveAutocompleteDropdown);
    pacObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: "hn" },
      fields: ["geometry", "address_components", "formatted_address", "name"],
    });

    autocomplete.bindTo("bounds", map);

    mapListeners.push(
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (!place.geometry?.location) {
          console.warn("No geometry en place");
          return;
        }

        const location = place.geometry.location;
        const address = place.formatted_address || place.name || null;

        map.setCenter(location);
        marker.setPosition(location);
        saveLocation(location, address);
      })
    );
  }

  function buildMap(center) {
    const normalizedCenter = normalizeLatLng(center?.lat, center?.lng) || getDefaultCenter();
    const mapEl = document.getElementById("map");
    const input = document.getElementById("mapSearch");

    if (!mapEl || !input || !window.google?.maps?.places) return;

    cleanupMapRuntime(false);

    mapEl.classList.add("loading");
    mapEl.innerHTML = "";
    input.value = "";

    map = new google.maps.Map(mapEl, {
      center: normalizedCenter,
      zoom: 15,
      gestureHandling: "greedy",
    });

    mapListeners.push(
      google.maps.event.addListenerOnce(map, "idle", () => {
        mapEl.classList.remove("loading");
      })
    );

    marker = new google.maps.Marker({
      position: normalizedCenter,
      map,
      draggable: true,
    });

    setupAutocomplete(input);

    mapListeners.push(
      marker.addListener("dragend", () => {
        saveLocation(marker.getPosition());
      })
    );

    setTimeout(() => {
      google.maps.event.trigger(map, "resize");
      map.setCenter(normalizedCenter);
    }, 300);

    mapReady = true;
  }

  async function resolveAddress(latLng, address) {
    if (address) return address;

    if (!window.google?.maps?.Geocoder) {
      return "Ubicación seleccionada";
    }

    try {
      const geocoder = new google.maps.Geocoder();
      const response = await geocoder.geocode({
        location: latLng,
      });

      if (response.results?.length) {
        return response.results[0].formatted_address;
      }
    } catch (err) {
      console.error("Error obteniendo dirección:", err);
    }

    return "Ubicación seleccionada";
  }

  async function saveLocationOnce(latLng, address = null) {
    const normalized = normalizeLatLng(latLng.lat, latLng.lng);
    if (!normalized) return null;

    const resolvedAddress = await resolveAddress(normalized, address);
    const data = {
      lat: normalized.lat,
      lng: normalized.lng,
      address: resolvedAddress,
      googleMapsUrl: `https://www.google.com/maps?q=${normalized.lat},${normalized.lng}`,
    };

    localStorage.setItem(LOCATION_STORAGE_KEY, JSON.stringify(data));
    document.dispatchEvent(
      new CustomEvent("valhalla:location-changed", {
        detail: {
          location: data,
        },
      })
    );

    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            "📍 Dirección": data.address,
            "🗺️ Google Maps": data.googleMapsUrl,
          },
        }),
      });
    } catch (err) {
      console.error("Error enviando ubicación:", err);
    }

    updateLocationButton();
    updateSavedAddressUI();

    try {
      await window.Shipping?.applyShippingLogic?.();
    } catch (err) {
      console.error("Error en shipping:", err);
    }

    scheduleFinalCheckoutValidation("location-saved", 80);
    schedulePostRenderCheckoutVisualSync("location-saved");
    console.log("Ubicación guardada:", data);

    return data;
  }

  function saveLocation(loc, address = null) {
    const latLng = extractLatLng(loc);

    if (!latLng) {
      console.warn("Ubicación inválida ignorada");
      return Promise.resolve(null);
    }

    locationSaveQueue = locationSaveQueue
      .catch(() => null)
      .then(() => saveLocationOnce(latLng, address));

    return locationSaveQueue;
  }

  function getLocationModal() {
    return document.getElementById("locationModal");
  }

  function getMapContainer() {
    mapContainerElement = document.querySelector(".cart-map-side") || mapContainerElement;
    return mapContainerElement;
  }

  function rememberMapContainerHome() {
    const mapContainer = getMapContainer();
    const modalBody = document.getElementById("locationModalBody");

    if (!mapContainer || !mapContainer.parentNode || mapContainer.parentNode === modalBody) return;

    if (!mapContainerHomeParent || !mapContainerHomeParent.isConnected) {
      mapContainerHomeParent = mapContainer.parentNode;
      mapContainerHomeNextSibling = mapContainer.nextSibling;
    }
  }

  function bindModalLifecycle() {
    const modal = getLocationModal();
    if (!modal || modal.dataset.locationLifecycleBound === "true") return;

    modal.dataset.locationLifecycleBound = "true";
    modal.addEventListener("close", () => {
      moveMapBackToCart();
      scheduleCheckoutStateUpdate(80);
    });
    modal.addEventListener("cancel", () => {
      setTimeout(moveMapBackToCart, 0);
    });
  }

  function moveMapIntoModal() {
    const modalBody = document.getElementById("locationModalBody");
    const mapContainer = getMapContainer();

    rememberMapContainerHome();
    if (modalBody && mapContainer && mapContainer.parentElement !== modalBody) {
      modalBody.appendChild(mapContainer);
    }
  }

  function moveMapBackToCart() {
    const mapContainer = getMapContainer();
    const originalParent =
      mapContainerHomeParent?.isConnected
        ? mapContainerHomeParent
        : document.querySelector("header-actions") || document.body;

    if (originalParent && mapContainer && mapContainer.parentElement !== originalParent) {
      if (mapContainerHomeNextSibling?.parentNode === originalParent) {
        originalParent.insertBefore(mapContainer, mapContainerHomeNextSibling);
      } else {
        originalParent.appendChild(mapContainer);
      }
    }
  }

  function isMapRuntimeHealthy() {
    const mapEl = document.getElementById("map");

    return Boolean(
      mapReady &&
        map &&
        marker &&
        mapEl &&
        mapEl.isConnected &&
        mapEl.querySelector(".gm-style")
    );
  }

  function ensureMapForOpen() {
    const mapEl = document.getElementById("map");

    if (mapEl && !isMapRuntimeHealthy()) {
      mapEl.classList.add("loading");
      cleanupMapRuntime();
      initMap();
      return;
    }

    if (isMapRuntimeHealthy()) {
      mapEl?.classList.remove("loading");
      resizeMapAfterOpen();
    } else {
      initMap();
    }
  }

  function openLocationModal() {
    const modal = getLocationModal();

    if (!modal) {
      console.error("MODAL NO EXISTE");
      return;
    }

    if (!modal.open) {
      modal.showModal();
    }

    bindModalLifecycle();
    moveMapIntoModal();

    const mapEl = document.getElementById("map");

    if (mapEl && !mapReady) {
      mapEl.classList.add("loading");
    }

    setTimeout(() => {
      ensureMapForOpen();
    }, 300);

    updateCheckoutState();
  }

  function bindLocationButton() {
    const buttons = document.querySelectorAll("#openLocationModalBtn");

    if (!buttons.length) {
      clearTimeout(bindButtonRetryTimer);
      bindButtonRetryTimer = setTimeout(bindLocationButton, 400);
      return;
    }

    updateLocationButton();
    rememberMapContainerHome();
    bindModalLifecycle();

    buttons.forEach((btn) => {
      if (btn.dataset.bound === "true") return;

      btn.dataset.bound = "true";
      btn.addEventListener("click", openLocationModal);
    });
  }

  function showLocationSavedAnimation() {
    document.querySelectorAll("#locationSavedMessage").forEach((savedMsg) => {
      savedMsg.classList.add("active");
    });

    updateSavedAddressUI();

    setTimeout(() => {
      document.querySelectorAll("#locationSuccess").forEach((success) => {
        success.classList.add("active");

        setTimeout(() => {
          success.classList.remove("active");
        }, 2000);
      });
    }, 100);
  }

  async function handleSaveLocationClick(event) {
    const saveBtn = event.target.closest("#saveLocationBtn");
    if (!saveBtn) return;

    event.preventDefault();

    if (!marker || isManualSaveInProgress) return;

    const modal = getLocationModal();
    const position = marker.getPosition();

    isManualSaveInProgress = true;
    saveBtn.disabled = true;
    saveBtn.setAttribute("aria-busy", "true");

    const savePromise = saveLocation(position);

    showLocationSavedAnimation();
    scheduleCheckoutStateUpdate(50);

    setTimeout(() => {
      if (modal?.open) {
        modal.close();
      }

      moveMapBackToCart();
    }, 1200);

    try {
      await savePromise;
    } finally {
      isManualSaveInProgress = false;
      saveBtn.disabled = false;
      saveBtn.removeAttribute("aria-busy");
      resetCheckoutTransientState(false);
      await forceFinalCheckoutRevalidation("location-save-complete");
      schedulePostRenderCheckoutVisualSync("location-save-complete");
    }
  }

  function handleCloseLocationModalClick(event) {
    const modal = getLocationModal();
    if (!modal?.open) return;

    const closeBtn = event.target.closest("#closeLocationModal");
    if (!closeBtn) return;

    event.preventDefault();
    modal.close();
    moveMapBackToCart();
  }

  function isCheckoutLink(target) {
    const link = target.closest?.('a[href*="/checkout"]');
    if (!link) return false;

    try {
      return new URL(link.href, window.location.origin).pathname.includes("/checkout");
    } catch (err) {
      return false;
    }
  }

  function isCheckoutClickTarget(target) {
    return Boolean(
      target.closest?.('button[name="checkout"], input[name="checkout"], #checkout') ||
        target.closest?.(".additional-checkout-buttons") ||
        target.closest?.(".shopify-payment-button__button") ||
        target.closest?.("shopify-accelerated-checkout-cart") ||
        isCheckoutLink(target)
    );
  }

  function getCheckoutControlFromTarget(target) {
    const control = target?.closest?.(CHECKOUT_SELECTOR);
    return isCheckoutControl(control) ? control : null;
  }

  function getCheckoutForm(control) {
    if (control instanceof HTMLButtonElement || control instanceof HTMLInputElement) {
      if (control.form) return control.form;

      const formId = control.getAttribute("form");
      if (formId) {
        const form = document.getElementById(formId);
        if (form instanceof HTMLFormElement) return form;
      }
    }

    const closestForm = control?.closest?.("form");
    if (closestForm instanceof HTMLFormElement) return closestForm;

    const cartForm = document.getElementById("cart-form");
    return cartForm instanceof HTMLFormElement ? cartForm : null;
  }

  function submitCheckoutForm(form, control = null) {
    if (!(form instanceof HTMLFormElement)) return false;

    if (
      typeof form.requestSubmit === "function" &&
      (control instanceof HTMLButtonElement || control instanceof HTMLInputElement) &&
      control.form === form
    ) {
      form.requestSubmit(control);
      return true;
    }

    const fallbackInput = document.createElement("input");
    fallbackInput.type = "hidden";
    fallbackInput.name = "checkout";
    fallbackInput.value = "checkout";
    form.appendChild(fallbackInput);
    form.submit();
    return true;
  }

  async function continueCheckoutAttempt(control, form = null) {
    if (!(control instanceof HTMLElement) && !(form instanceof HTMLFormElement)) return;

    const ready = await forceFinalCheckoutRevalidation("checkout-attempt");

    if (!ready) {
      if (getStoredLocation()) {
        requestShippingSyncOnce("checkout-attempt");
      }

      return;
    }

    isReplayingCheckoutAttempt = true;

    try {
      if (control instanceof HTMLAnchorElement && control.href) {
        window.location.href = control.href;
        return;
      }

      const checkoutForm = form || getCheckoutForm(control);

      if (checkoutForm instanceof HTMLFormElement) {
        submitCheckoutForm(checkoutForm, control);
        return;
      }

      control?.click?.();
    } finally {
      setTimeout(() => {
        isReplayingCheckoutAttempt = false;
      }, 0);
    }
  }

  function blockCheckoutAttempt(event, control = null, form = null) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();

    continueCheckoutAttempt(control || getCheckoutControlFromTarget(event.target), form);
  }

  function handleCheckoutClick(event) {
    if (isReplayingCheckoutAttempt) return;
    if (!isCheckoutClickTarget(event.target)) return;

    if (!checkoutReady) {
      blockCheckoutAttempt(event, getCheckoutControlFromTarget(event.target));
    }
  }

  function handleCheckoutSubmit(event) {
    if (isReplayingCheckoutAttempt) return;

    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const submitter = event.submitter;
    const isCheckoutSubmitter =
      submitter?.matches?.('button[name="checkout"], input[name="checkout"], #checkout') ||
      form.querySelector('button[name="checkout"], input[name="checkout"], #checkout');

    if (!isCheckoutSubmitter) return;

    if (!checkoutReady) {
      const control =
        submitter instanceof HTMLElement && isCheckoutControl(submitter)
          ? submitter
          : form.querySelector('button[name="checkout"], input[name="checkout"], #checkout');

      blockCheckoutAttempt(event, control, form);
    }
  }

  function queueLocationUiSync() {
    clearTimeout(locationUiTimer);
    locationUiTimer = setTimeout(() => {
      updateLocationButton();
      updateSavedAddressUI();
      bindLocationButton();
      updateCheckoutState();
      scheduleFinalCheckoutValidation("location-ui-sync", 80);
    }, 300);
  }

  function resetCheckoutTransientState(force = false) {
    const shippingState = window.Shipping?.getSyncState?.();

    if (force || !shippingState?.isProcessing) {
      checkoutSyncPromise = null;
    }

    clearTimeout(checkoutUpdateTimer);
    clearTimeout(finalCheckoutValidationTimer);
    pendingFinalCheckoutRevalidation = false;
    checkoutStateRequestId += 1;
    isManualSaveInProgress = false;
  }

  function refreshStateAfterResume(reason = "resume") {
    clearTimeout(resumeStateTimer);
    resumeStateTimer = setTimeout(() => {
      const forceReset = reason === "pageshow" || reason === "visibilitychange";

      resetCheckoutTransientState(forceReset);
      updateLocationButton();
      updateSavedAddressUI();
      syncLocationMessaging();
      bindLocationButton();
      updateCheckoutState();
      scheduleFinalCheckoutValidation(reason, 120);
    }, 80);
  }

  function initLocationState() {
    const saved = getStoredLocation();

    if (saved) {
      updateSavedAddressUI();

      if (window.Shipping?.applyShippingLogic) {
        setTimeout(() => {
          window.Shipping.applyShippingLogic();
        }, 300);
      }
    } else {
      resetSavedAddressUI();
    }

    updateLocationButton();
    syncLocationMessaging();
    rememberMapContainerHome();
    updateCheckoutState();
    scheduleFinalCheckoutValidation("init", 160);
    bindModalLifecycle();
    bindLocationButton();
  }

  if (!window[LOCATION_EVENTS_KEY]) {
    document.addEventListener("click", handleSaveLocationClick, true);
    document.addEventListener("click", handleCloseLocationModalClick, true);
    document.addEventListener("click", handleCheckoutClick, true);
    document.addEventListener("submit", handleCheckoutSubmit, true);

    document.addEventListener("click", () => {
      queueLocationUiSync();
    });

    document.addEventListener("valhalla:shipping-state", (event) => {
      const detail = event.detail || {};

      if (detail.ready === false && (detail.isProcessing || detail.pendingSync || detail.reason === "syncing" || detail.reason === "sync-queued")) {
        setCheckoutBlocked(true, "syncing-shipping");
      }

      if (detail.ready === true && !detail.isProcessing && !detail.pendingSync) {
        scheduleFinalCheckoutValidation("shipping-state-ready", 80);
        schedulePostRenderCheckoutVisualSync("shipping-state-ready");
      }

      scheduleCheckoutStateUpdate(80);
    });

    document.addEventListener("valhalla:cart-mutated", () => {
      scheduleCheckoutStateUpdate(120);
      scheduleFinalCheckoutValidation("cart-mutated", 220);
    });

    document.addEventListener("valhalla:shipping-updated", () => {
      scheduleCheckoutStateUpdate(80);
      scheduleFinalCheckoutValidation("shipping-updated", 120);
      queueLocationUiSync();
    });

    document.addEventListener("valhalla:shipping-sync-complete", () => {
      scheduleFinalCheckoutValidation("shipping-sync-complete", 80);
      schedulePostRenderCheckoutVisualSync("shipping-sync-complete");
      queueLocationUiSync();
    });

    document.addEventListener("valhalla:cart-drawer-refreshed", () => {
      queueLocationUiSync();
      scheduleFinalCheckoutValidation("cart-drawer-refreshed", 80);
      schedulePostRenderCheckoutVisualSync("cart-drawer-refreshed");
    });

    document.addEventListener("valhalla:location-changed", () => {
      queueLocationUiSync();
      scheduleCheckoutStateUpdate(80);
      scheduleFinalCheckoutValidation("location-changed", 180);
    });

    document.addEventListener("valhalla:observer-idle", () => {
      scheduleCheckoutStateUpdate(60);
      scheduleFinalCheckoutValidation("observer-idle", 80);
    });

    document.addEventListener("DOMContentLoaded", initLocationState);
    document.addEventListener("shopify:section:load", () => {
      initLocationState();
      scheduleFinalCheckoutValidation("shopify-section-load", 120);
    });

    window.addEventListener("pageshow", () => {
      refreshStateAfterResume("pageshow");
    });

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        refreshStateAfterResume("visibilitychange");
      }
    });

    window.addEventListener("focus", () => {
      refreshStateAfterResume("focus");
    });

    window.addEventListener("popstate", () => {
      refreshStateAfterResume("popstate");
    });

    window[LOCATION_EVENTS_KEY] = true;
  }

  setTimeout(initLocationState, 500);

  window.updateCheckoutState = updateCheckoutState;
  window.updateLocationButton = updateLocationButton;
  window.updateSavedAddressUI = updateSavedAddressUI;
  window.waitForGoogleMaps = waitForGoogleMaps;
  window.waitForMapContainer = waitForMapContainer;
  window.initMap = initMap;
  window.buildMap = buildMap;
  window.saveLocation = saveLocation;
  window.bindLocationButton = bindLocationButton;
  window.initLocationState = initLocationState;
})();
